import { gql, MutationHookOptions, useMutation } from "@apollo/client";

/*
 * Hand-written like its sibling `updateVatAnnualDeclaration.ts`: `pnpm gen`
 * needs a backend that already serves this mutation. Replace by the generated
 * hook once the backend schema is deployed to staging.
 *
 * `amount` is in cents; `queryDate` is the raw ELSTER date string
 * ("02.10.2026 13:26:14") and may be null.
 */
export interface FillTaxOfficeBalanceFromTaxAccountMutationVariables {
  email: string;
  year: number;
}

export interface FillTaxOfficeBalanceFromTaxAccountMutationResult {
  fillTaxOfficeBalanceFromTaxAccount: {
    amount: number;
    taxNumber: string;
    queryDate: string | null;
    declaration: {
      taxOfficeBalance: number | null;
    };
  };
}

export const FILL_TAX_OFFICE_BALANCE_FROM_TAX_ACCOUNT_MUTATION = gql`
  mutation fillTaxOfficeBalanceFromTaxAccount($email: String!, $year: Int!) {
    fillTaxOfficeBalanceFromTaxAccount(email: $email, year: $year) {
      amount
      taxNumber
      queryDate
      declaration {
        status
        statusUpdatedAt
        lastYearIncomeAdjustment
        currentYearIncomeAdjustment
        taxOfficeBalance
      }
    }
  }
`;

export const useFillTaxOfficeBalanceFromTaxAccountMutation = (
  options?: MutationHookOptions<
    FillTaxOfficeBalanceFromTaxAccountMutationResult,
    FillTaxOfficeBalanceFromTaxAccountMutationVariables
  >
) =>
  useMutation<
    FillTaxOfficeBalanceFromTaxAccountMutationResult,
    FillTaxOfficeBalanceFromTaxAccountMutationVariables
  >(FILL_TAX_OFFICE_BALANCE_FROM_TAX_ACCOUNT_MUTATION, options);
